export default __webpack_public_path__ + "static/media/icon-es-time.68757675.svg";